/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_TimezoneInputs */



/**
* | output |
* | --- |
* | "Time zone" |
*
* @param {Settings_TimezoneInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_timezone = /** @type {((inputs?: Settings_TimezoneInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_TimezoneInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Tijdzone")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fuseau horaire")
	return /** @type {LocalizedString} */ ("Time zone")
});